import Superscript from "utils/superscript";

module.exports = {
    init: function (element) {
        let items = element.querySelectorAll('.js-sscr-item');

        items.forEach(item => {
            let sTarget = item.dataset.jsSscr;
            let s = new Superscript(item, sTarget);
        });
    }
};